export const EMAIL_SUPPORT = "kodanda.devarakonda@gmail.com";
export const PHONE_SUPPORT = "+91 9642448820";

export const API_BASE_URL = "https://rk-backend-mauve.vercel.app/v1";
// export const API_BASE_URL = "http://localhost:5200/v1";